export default __webpack_public_path__ + "static/media/coinbaseWalletIcon.dba3cd09.svg";